var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExcesoVelocidad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 208.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{fill:#0000e2;}.cls-2{opacity:0.1;}.cls-3{opacity:0.2;}.cls-4{opacity:0.3;}.cls-5{opacity:0.4;}.cls-6{opacity:0.5;}.cls-7{opacity:0.6;}.cls-8{opacity:0.7;}.cls-9{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-exceso-velocidad") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_25",
    "data-name": 25
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.12,132.05A126.12,126.12,0,0,1,242,184.18L227.1,176.8a109.5,109.5,0,0,0,11.37-44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,132.74a126.17,126.17,0,0,0,13.11,51.43L28,176.8a109.62,109.62,0,0,1-11.4-44.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.94,76.53A110.28,110.28,0,0,0,16.64,122L0,122A126.62,126.62,0,0,1,14.51,68.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.57,34.14A111.91,111.91,0,0,0,33.82,68.07L19.76,59.25A128.47,128.47,0,0,1,59.08,19.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122,16.65A110.26,110.26,0,0,0,76.25,29.09L67.59,14.88A126.74,126.74,0,0,1,122.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.86,29.1a110.38,110.38,0,0,0-46.81-12.5L132.39,0a126.65,126.65,0,0,1,54.44,14.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M220.76,67.26a112.09,112.09,0,0,0-34-33.59l8.71-14.13a128.49,128.49,0,0,1,39.85,39.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M238.45,122a110.17,110.17,0,0,0-12.58-46l14.48-8.12A126.58,126.58,0,0,1,255.07,122Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M124,140.43a25.57,25.57,0,1,1,22.17-38.25l53.54,37.95-65.6-1.81A25.42,25.42,0,0,1,124,140.43Zm0-39.62a14.06,14.06,0,0,0-13.33,9.6,14,14,0,0,0,19.65,17l1.3-.66,30.47.84-24.87-17.63-.64-1.3A14,14,0,0,0,124,100.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M172.88,208.74H82.24a10.09,10.09,0,0,1-10.08-10.08V185a10.09,10.09,0,0,1,10.08-10.08h90.64A10.09,10.09,0,0,1,183,185v13.67A10.09,10.09,0,0,1,172.88,208.74Zm-89.2-11.52h87.76V186.43H83.68Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExcesoVelocidad);
export default __webpack_public_path__ + "static/media/ic-exceso-velocidad.02c15f7873d709a17e3acf68cb515e4c.svg";
export { ForwardRef as ReactComponent };